module.exports = __webpack_public_path__ + "static/img/div-top-bg.4f542c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/div-top-bg.png
// module id = umH9
// module chunks = 1